import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { UnidadOrgService } from '../../../services/formulacion/unidad-org.service';
import { RolesService, SiapService } from 'src/app/services/service.index';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import LoadOptions from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';


declare const toastr: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: []
})
export class UsersComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataSource: any;
  numRegistrosPorPagina: number = 10;
  paginaActual: number = 1;
  cantidadRegistros: number;
  paginaAnterior: number;
  paginaSiguiente: number;
  correo: string = 'correo@minedu.gob.bo';
  baseUrl = environment.apiEndpoint;
  parametros: any;
  customDataSource: DataSource;
  token: string = '';
  dataUsers: any[];
  popupVisibleUs: boolean = false;
  popupVisibleAdd: boolean = false;
  popupVisibleAddRol: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleApr: boolean = false;
  popupVisibleRP: boolean = false;
  estado: any[];
  hasError: any;
  unidades: any[];
  roles: any[];
  funcionarioSIAP: any[];
  rolesAsignados: any[];
  idRolAsigado: number = 0;
  cantidadRoles: number = 0;
  model: any = {
    id: 0,
    name: '',
    email: '',
    ci: '',
    estado: '',
    estado_id: '',
    rol: '',
    rol_id: '',
    unidadl: '',
    unidad_id: '',
    usuario: '',
    siap_id: 0,
    image_path:'S/I',
    cargo_id: 0,
    tipo_agregacion_id: 0
  };
  tipo_agregacion_id: number = 1;

  constructor(
    private _gs: GeneralService,
    private _uos: UnidadOrgService,
    private _rs: RolesService,
    private httpClient: HttpClient,
    private _siaps: SiapService
  ) {
    this.estado = [{ text: 'Activo', value: 1 }, { text: 'Inactivo', value: 2 }];
    this.clearErrors();
    this.getPoaUsers();
    this.getRolesUsuarios();
    this.getUnidades(); 
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { estado_id: false, unidad_id: false, roles_id: false, name: false, email: false, ci: false, usuario: false };
  }

  getPoaUsers() {
    this._gs.getUsuariosPoa().subscribe(
      (response) => {
        let result = response;
        if (result.status == 200) {
          
          this.dataUsers = result.data;
        } else { this.dataUsers = []; }
      },
      (error) => { console.log('Error', error); });
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.name = data.name;
    this.model.email = data.email;
    this.model.estado_id = data.estado_id;
    this.model.rol_id = data.rol_id;
    this.model.unidad_id = data.unidad_id;
    this.model.ci = data.ci;
    this.model.usuario = data.usuario;
    this.popupVisibleAdd = true;
  }

  showModalAdd(data: any) {
    this.clearErrors();
    this.model.id = '';
    this.model.name = '';
    this.model.email = '';
    this.model.estado_id = '';
    this.model.rol_id = '';
    this.model.unidad_id = '';
    this.model.ci = '';
    this.model.estado_id = '';
    this.model.usuario = '';
    this.popupVisibleAdd = true;

  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  onToolbarPreparingA(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  getUnidades() {
    this._uos.getUnidadOrg().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.unidades = result.data;
        } else {
          this.unidades = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getRolesUsuarios() {
    this._gs.getRoles().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.roles = result.data;
        } else {
          this.roles = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  saveUser() {
    this.clearErrors();
    
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._gs.postUsuarioPoa(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getPoaUsers();
              this.popupVisibleAdd = false;
              toastr.success('Usuario registrado correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          (error) => { console.log('Error', error); });
      }
      else {
        this._gs.putUsuarioPoa(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getPoaUsers();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.name, 'text')) {
      this.hasError.name = true; res = false;
    }
    if (!UtilHelper.validator(data.ci, 'text')) {
      this.hasError.ci = true; res = false;
    }
   
    if (!UtilHelper.validator(data.usuario, 'text')) {
      this.hasError.usuario = true; res = false;
    }
    return res;
  }

  showModalAddRol(data: any) {
    this.clearErrors();
    this.rolesAsignados = [];
    this.getRolesAsignados(data.id);
    this.model.id = data.id;
    this.model.name = data.name;
    this.model.email = data.email;
    this.model.rol_id = data.rol_id;
    this.popupVisibleAddRol = true;

  }

  getRolesAsignados(id: number) {
    this._rs.getRolAsignadoUsuario(id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.rolesAsignados = result.data;
          this.cantidadRoles = result.data.lenght;
        } else {
          this.rolesAsignados = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalDeleteRol(id: number) {
    this.idRolAsigado = id;
    this.popupVisibleDel = true;
  }

  deleteRol() {
    this._rs.deleteRolAsignado(this.idRolAsigado).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getRolesAsignados(this.model.id);
          this.popupVisibleDel = false;
          toastr.success('Eliminado correctamente.');
        }
      },
      error => { console.log('Error', error); });
  }

  saveUserRol() {
    if (this.validateRolAsignado(this.model)) {
      if (this.model.id != 0) {
        this._rs.postUsuarioRol(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getRolesAsignados(this.model.id);              
              toastr.success('Rol asignado correctamente.');
            } else if (result.status == 201) {
              toastr.warning(result.data);
            } else {
              toastr.warning(result.data);
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  validateRolAsignado(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.rol_id, 'integer')) {
      this.hasError.rol_id = true; res = false;
    }
    return res;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

}
